<main>

  <div class="mx-4 mb-10">
    <h3 class="text-4xl font-bold mb-2">Reclamações</h3>
    <p class="text-sm">Lista de reclamações dos utilizadores relativamente as ocorrências submetidas.</p>
  </div>

  <!-- content wrapper -->
  <div class="bg-white p-5 border border-round">

    <!-- filtros aqui -->
    <div class="my-5">
      <app-report-filters (submitFilter)="onFilterSubmit($event)"></app-report-filters>
    </div>


    <div>
      <p-table [value]="reportList" styleClass="text-xs" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>Nome/Título</th>
            <th>Reportador</th>
            <th>Criador da Ocorrência</th>
            <th>Estado</th>
            <th>Data da reclamação</th>
            <th>Açcões</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-report>

          <tr>
            <td>{{ report.eventName }}</td>
            <td>{{ report.reporterName | titlecase }}</td>
            <td>{{ report.reporteeName }}</td>
            <td>{{ report.status?.description | titlecase }}</td>
            <td>{{ report.creationDate | date:'yyyy-MM-dd' }}</td>
            <td><i (click)="selectObjectForDropDown(report) ; setMouseEvent($event)"
            class="btn pi pi-cog cursor-pointer"></i></td>
          </tr>
        </ng-template>
      </p-table>

      @if (!tablehasData) {
        <p class="flex justify-center text-sm text-gray-500 font-medium my-10">Nenhuma reclamação
          foi
        encontrada, por favor verifique os filtros</p>
      }
    </div>

    @if (pagination) {
      <app-paginator [paginationDetails]="pagination"
        (pageChangeEvent)="onPageChange($event)"
      ></app-paginator>
    }
  </div>

</main>

<app-complaint-drop-down
  (onCloseComplaintSuccess)="onCloseComplaintSuccess($event)"
  [complaint]="selectedReport" [clickEvent]="mouseEvent">
</app-complaint-drop-down>
